import { env_uat } from "./env-uat"
import { env_pro } from "./env-pro" 

export const runtimeEnv = (window as any).__EQUIPAJES_CONFIG__ || {}

var environmentVars = runtimeEnv.REACT_APP_HOST_ENV === 'production' ? env_pro : env_uat;

export const environment = 
{
  reactAppEnv: runtimeEnv.REACT_APP_HOST_ENV,
  env: environmentVars.NODE_ENV,
  debug: environmentVars.NODE_ENV === 'production' ? false : true,
  endpoints: {
    apiversion: `${environmentVars.BASE_URL}/api/version`,
    pirs:`${environmentVars.BASE_URL}/api/Pirs`,
    languages:`${environmentVars.BASE_URL}/api/Languages`,
    countries : `${environmentVars.BASE_URL}/api/Countries/`,
    records:`${environmentVars.BASE_URL}/api/Records`,
    Dprs:`${environmentVars.BASE_URL}/api/Dprs`,
    phones:`${environmentVars.BASE_URL}/api/Phones`,
    deliveries:`${environmentVars.BASE_URL}/api/Deliveries`,
    getCodePostalIslands:`${environmentVars.BASE_URL}/api/Deliveries/GetCodePostalIslands`,
    suitcases: `${environmentVars.BASE_URL}/api/Suitcases`,
    pirs_where_to_go:`${environmentVars.BASE_URL}/api/Pirs/where-to-go`,
    auth: `${environmentVars.BASE_URL}/api/AuthorizeTest`,
    configuration: `${environmentVars.BASE_URL}/api/Configuration`,
    getListYear:`${environmentVars.BASE_URL}/api/Suitcases/suitcase-age`,
    getListSize:`${environmentVars.BASE_URL}/api/Suitcases/suitcase-size`,
    stores:`${environmentVars.BASE_URL}/api/Stores`,
    getBaggagesCarousel:`${environmentVars.BASE_URL}/api/Xml`
  },
  static:{
    translate: `${environmentVars.BASE_URL}/api/contentproxy/locales/`,
    imagesMaletas : `${environmentVars.BASE_URL}/api/contentproxy/assets/maletas/`,
    pdfs: `${environmentVars.BASE_URL}/api/contentproxy/assets/pdfs`,
    privacyPolicy: `${environmentVars.BASE_URL}/api/contentproxy/assets/pdfs/privacy_policy`
  },
  files: {
    maxSize: 20000000,
    fileTypesAllowed: ['doc', 'txt', 'csv', 'xml', 'zip'],
  },
  redirects: {
    vueling: 'https://www.vueling.com/es/somos-vueling/contacto/gestiones?helpCenterFlow=Baggage'
  },
};
